import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { EmptyState } from '../../components/common/Misc';
import Button from '../../components/common/Button';
import styles from './CartPage.module.css';
import { format } from 'date-fns';

const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || '';
const resolveImg = (url) => (url && url.startsWith('http') ? url : `${API_BASE}${url}`);


const CartPage = () => {
  const { items, removeFromCart, clearCart, cartTotal } = useCart();
  const navigate = useNavigate();

  if (items.length === 0) return (
    <div className="container">
      <EmptyState icon="🛒" title="Your cart is empty" subtitle="Browse bikes and add them to your cart" />
      <div style={{ textAlign: 'center', marginTop: '1rem' }}>
        <Link to="/bikes"><Button>Browse bikes</Button></Link>
      </div>
    </div>
  );

  return (
    <div className="container">
      <div className={styles.header}>
        <h1 className={styles.title}>Your cart</h1>
        <button className={styles.clearBtn} onClick={clearCart}>Clear all</button>
      </div>

      <div className={styles.layout}>
        {/* Items list */}
        <div className={styles.items}>
          {items.map(item => (
            <div key={item.bike._id} className={styles.item}>
              <div className={styles.itemImg}>
                {item.bike.images?.[0]
                  ? <img src={resolveImg(item.bike.images[0])} alt={item.bike.name} />
                  : <span>🏍️</span>
                }
              </div>
              <div className={styles.itemInfo}>
                <div className={styles.itemTop}>
                  <h3 className={styles.itemName}>{item.bike.name}</h3>
                  <button className={styles.removeBtn} onClick={() => removeFromCart(item.bike._id)}>✕</button>
                </div>
                <p className={styles.itemBrand}>{item.bike.brand} · {item.bike.type}</p>
                <div className={styles.itemDates}>
                  <span>🗓 {format(new Date(item.startTime), 'dd MMM, HH:mm')}</span>
                  <span>→</span>
                  <span>{format(new Date(item.endTime), 'dd MMM, HH:mm')}</span>
                  <span className={styles.duration}>({item.days} day{item.days > 1 ? 's' : ''})</span>
                </div>
                {item.promoCode && (
                  <p className={styles.promoTag}>🏷 {item.promoCode}  saving ₹{item.discountAmount.toFixed(2)}</p>
                )}
              </div>
              <div className={styles.itemPrice}>
                {item.discountAmount > 0 && (
                  <span className={styles.originalPrice}>₹{item.totalAmount.toFixed(2)}</span>
                )}
                <span className={styles.finalPrice}>₹{item.finalAmount.toFixed(2)}</span>
                <span className={styles.gstLabel}>incl. 18% GST</span>
              </div>
            </div>
          ))}
        </div>

        {/* Order summary */}
        <div className={styles.summary}>
          <h2 className={styles.summaryTitle}>Order summary</h2>
          {items.map(item => (
            <div key={item.bike._id} className={styles.summaryRow}>
              <span className={styles.summaryBike}>{item.bike.name}</span>
              <span>₹{item.finalAmount.toFixed(2)}</span>
            </div>
          ))}
          <div className={styles.summaryDivider} />
          <div className={styles.summaryTotal}>
            <span>Total</span>
            <span>₹{cartTotal.toFixed(2)}</span>
          </div>
          <Button fullWidth size="lg" onClick={() => navigate('/place-order')}>
            Proceed to order →
          </Button>
          <Link to="/bikes">
            <Button variant="ghost" fullWidth>Continue browsing</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
